import { call, put } from "redux-saga/effects";
import { createCourseActions, editingCourseActions } from "../slices";
import { courseAPI } from "@services/api/course";
import { uploadAPI } from "@services/api/upload/upload";
import { toast } from "react-toastify";

function* createCourseWorker({ payload }) {
  try {
    yield put(createCourseActions.pending());

    yield put(editingCourseActions.resetEditingCourse());

    // const course = payload;

    // yield put(editingCourseActions.splitUnits());

    // const editingCourse = yield select((state) => state.course.editingCourse);

    // const { thumbnailImg, previewVideo } = editingCourse;

    // let additionalInfo = {};

    // if (thumbnailImg) {
    //   const uploadImageResponse = yield call(
    //     uploadAPI.uploadImage,
    //     thumbnailImg
    //   );
    //   const urlImg = uploadImageResponse.url;
    //   additionalInfo = { ...additionalInfo, thumbnailUrl: urlImg };
    // }

    // if (previewVideo) {
    //   const uploadVideoResponse = yield call(
    //     uploadAPI.uploadVideo,
    //     previewVideo
    //   );
    //   const urlVideo = uploadVideoResponse.url;
    //   additionalInfo = { ...additionalInfo, previewVideoUrl: urlVideo };
    // }

    const response = yield call(courseAPI.createCourse, {
      // ...editingCourse,
      // ...additionalInfo,
      // thumbnailUrl: uploadImageResponse.data.url,
      // previewVideoUrl: uploadVideoResponse.data.url,
    });
    yield put(editingCourseActions.updateCourse(response.data));

    // yield put(createCourseActions.success(response));
    yield put(createCourseActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(createCourseActions.failure(error));
    toast("Opps! Create course has failed", { type: "error" });
    // TODO: handle callback | onFailure
  }
}

export { createCourseWorker };
